import React from 'react';
import { DynamicTabs } from 'components/Tabs/DynamicTabs';

export default ({ tabs, ...props }) => {
  return <DynamicTabs tabs={tabs} useLinks {...props} />;
};
